import React, { useCallback, useEffect, useState } from 'react'
import { AddAttachmentsRPUtils } from '../utils/AddAttachmentsRPUtils'
import { IAddAttachmentsRPTestReportModel } from '../interfaces/IAddAttachmentsRPTestReportModel'

const useRPTestReportValidator = (rpAttachmentSource: IAddAttachmentsRPTestReportModel[]) => {
  const [isValid, setIsValid] = useState<boolean>(true)

  const validateRPTestReports = useCallback(() => {
    setIsValid(true)

    //check if has any invalid rows and its supporting documents row
    if (
      rpAttachmentSource?.some(tr => !tr.isValid) ||
      rpAttachmentSource?.some(tr => tr.supportingDocuments.some(suppDoc => !suppDoc.isValid))
    ) {
      setIsValid(false)
      return
    }
    // check if report number is required and check if report number is not empty.
    if (
      rpAttachmentSource?.some(
        tr => !tr.reportNumber && AddAttachmentsRPUtils.isReportNumberRequired(tr.contentGroup)
      )
    ) {
      setIsValid(false)
      return
    }

    //check if content groups and type is empty.
    if (
      rpAttachmentSource?.some(tr => !tr.contentGroup || !tr.type || !tr.fileNumber) ||
      rpAttachmentSource?.some(tr =>
        tr.supportingDocuments.some(
          suppDoc => !suppDoc.contentGroup || !suppDoc.type || !suppDoc.fileNumber
        )
      )
    ) {
      setIsValid(false)
      return
    }

    //check if certificate number is required and certificate number is not empty.
    if (
      rpAttachmentSource?.some(tr =>
        tr.supportingDocuments.some(
          suppDoc =>
            AddAttachmentsRPUtils.isContentGroupTRCertificate(suppDoc.contentGroup) &&
            !suppDoc.certificateNumber
        )
      )
    ) {
      setIsValid(false)
      return
    }
  }, [rpAttachmentSource])

  useEffect(() => {
    validateRPTestReports()
  }, [validateRPTestReports])

  return isValid
}

export default useRPTestReportValidator
